import React, { useRef, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { useCreateNotificationMutation } from "App/services/notificationServiceApi";
// import JoditEditor from "jodit-react";
// import { config } from "components/EditorConfig";
import EditorComponents from "components/Editor/EditorComponents";

export default function NotificationFormDialog() {
  const [open, setOpen] = useState(false);
  const [heading, setHeading] = useState("");
  const [message, setMessage] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [imgError, setImgError] = useState("");
  const [details, setDetails] = useState("");
  const [createNotification, { isLoading }] = useCreateNotificationMutation();
  const editor = useRef(null);
  // const editorRef = useRef(null);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setHeading("");
    setMessage("");
    setDetails("");
    setImage(null);
    setImagePreview("");
    setImgError("");
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
      setImgError("");
    }
  };

  const handleAddNotification = async (event) => {
    event.preventDefault();

    let newDetails = details.split('<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>')

    const formData = new FormData();

    formData.append("heading", heading);
    formData.append("message", message);
    formData.append("notificationData", newDetails);
    if (image) formData.append("imagePath", image);

    // console.log("heading ===> ", heading)
    // console.log("message ===> ", message)
    // console.log("image ===> ", image)
    try {
      await createNotification(formData).unwrap();
      toast.success("Notification Successfully sent!");
      handleClose();
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };

  return (
    <div>
      <Button variant="contained" color="light" onClick={handleClickOpen}>
        Add Notification
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: handleAddNotification,
        }}
      >
        <DialogTitle>Add Notification</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="heading"
            label="Notification Heading"
            type="text"
            fullWidth
            value={heading}
            onChange={(e) => setHeading(e.target.value)}
          />
          <TextField
            margin="dense"
            id="message"
            label="Notification Message"
            type="text"
            fullWidth
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ marginTop: "25px" }}
          />
          <br></br>

          <label>Notification Details</label>
          {/* <Editor
            apiKey={`${EDITOR_API_KEY}`}
            onInit={(_evt, editor) => (editorRef.current = editor)}
            initialValue={details}
            init={init}
            onEditorChange={newDetails => setDetails(newDetails)}
          /> */}
          {/* <JoditEditor
            ref={editor}
            value={details}
            config={config}
            onChange={(newDetails) => setDetails(newDetails)}
          /> */}

          <EditorComponents
            content={details}
            handleChangeContent={(newDetails) => setDetails(newDetails)}
          />

          {imagePreview && (
            <div style={{ marginTop: "16px" }}>
              <img
                src={imagePreview}
                alt="Preview"
                style={{ maxWidth: "100%", maxHeight: "300px" }}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" disabled={isLoading}>
            {isLoading ? "Adding..." : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
